import $ from 'jquery';

window.addEventListener('DOMContentLoaded', () => {
    let spinnerVisible = false;
    const spiner = document.querySelector('.js-spinner');
    function showProgress() {
        if (!spiner) return;
        if (!spinnerVisible) {
            spiner.classList.add('spinner-show');
            spinnerVisible = true;
        }
    }

    function hideProgress() {
        if (!spiner) return;
        if (spinnerVisible) {
            spiner.classList.remove('spinner-show');
            spinnerVisible = false;
        }
    }

    $(document).on('submit', '#codeSearchForm', (e) => {
        e.preventDefault();
        const postcode = $('#postcode').val();

        if (!postcode) {
            alert('Please enter a postcode, building or street name');

            return;
        }

        const directoryUrl = '/the-code/code-search/' + $('#postcode').val();

        showProgress();

        $.get(directoryUrl, (data) => {
            $('#codeSearchResults').hide().html(data).fadeIn('slow');
            hideProgress();
        });
    });
});
